import styled from 'styled-components';

import * as Common from '../../Styles';

export const RootContainer = styled(Common.RootContainer)``;

export const FlexRow = styled(Common.FlexRow)``;

export const ErrorImage = styled.img`
	width: 300px;
	height: 300px;
	align-self: center;
`;

export const Button = styled(Common.Button)``;
